<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 产品与服务 / AIOT 服务</p>
        <h1>AIOT 服务</h1>
        <p class="lede">
          以「硬件—云端—应用—生态」闭环为核心，提供设备接入、物联网方案、智能硬件定制与智慧行业系统，
          帮助企业快速完成数智化转型。
        </p>
      </div>
    </section>

    <div class="ui-container">
      <div class="float-panel">
        <div class="svc-grid">
          <div class="svc" v-for="s in aiotServices" :key="s.name">
            <div class="svc__pic">
              <img :src="s.image" :alt="s.name" />
            </div>
            <div class="svc__body">
              <h3>{{ s.name }}</h3>
              <p class="svc__desc">{{ s.desc }}</p>
              <ul class="check-list">
                <li v-for="pt in s.points" :key="pt">{{ pt }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作流程 -->
    <section class="section section--gray">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">PROCESS</span>
          <h2>四步合作流程</h2>
          <p class="sub">从需求到运维的闭环交付</p>
        </div>
        <div class="flow">
          <div class="flow__item card" v-for="p in aiotProcess" :key="p.step">
            <span class="flow__step">{{ p.step }}</span>
            <h3>{{ p.name }}</h3>
            <p>{{ p.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { aiotServices, aiotProcess } from "../data/site.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        aiotServices,
        aiotProcess
      };
    }
  };
</script>

<style scoped>
  .svc-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 28px;
  }
  .svc {
    display: flex;
    gap: 18px;
    align-items: flex-start;
  }
  .svc__pic {
    flex: none;
    width: 120px;
    height: 120px;
    border-radius: 14px;
    overflow: hidden;
    background: #fdeceb;
    border: 1px solid #f6e0dd;
  }
  .svc__pic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .svc__body { flex: 1; }
  .svc h3 { font-size: 17px; }
  .svc__desc {
    margin-top: 6px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.75;
  }
  .svc .check-list { margin-top: 8px; }
  .svc .check-list li { font-size: 13px; line-height: 1.8; }

  .flow {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  .flow__item { padding: 26px 24px; }
  .flow__step {
    font-size: 15px;
    font-weight: 800;
    color: #e8382f;
    letter-spacing: 0.06em;
  }
  .flow__item h3 { margin-top: 8px; font-size: 17px; }
  .flow__item p {
    margin-top: 8px;
    font-size: 13px;
    color: #8a909b;
    line-height: 1.7;
  }

  /* ---------- 响应式 ---------- */
  @media (max-width: 1023px) {
    .flow { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 767px) {
    .svc-grid { grid-template-columns: 1fr; gap: 18px; }
    .svc { gap: 14px; }
    .svc__pic { width: 90px; height: 90px; }
    .flow { grid-template-columns: 1fr; }
    .flow__item { padding: 20px 18px; }
  }
</style>
